"use client";
import {JSX} from "react";

import "./styles/spinner.scss";

interface SpinnerProps {
    size?: "small" | "medium" | "large";
    fullScreen?: boolean;
    text?: string;
    zIndex?: number;
}

export function Spinner({size = "medium", fullScreen = false, text, zIndex}: SpinnerProps): JSX.Element {
    if (fullScreen) {
        return (
            <div className="spinner-overlay" style={zIndex !== undefined ? {zIndex} : undefined}>
                <div className="spinner-content">
                    <div className={`spinner spinner--${size}`}>
                        <div className="spinner__circle"></div>
                    </div>
                    {text && <p className="spinner__text">{text}</p>}
                </div>
            </div>
        );
    }

    return (
        <div className={`spinner spinner--${size}`}>
            <div className="spinner__circle"></div>
        </div>
    );
}
